import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import Filtro from './Filtro';
import MovimentacaoRow from './MovimentacaoRow';
import TransferenciaRow from './TransferenciaRow';

class ExtratoMensal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            extrato: { saldoInicial: 0, saldoFinal: 0, linhas: [] },
        };
    }

    componentDidMount = async () => {
        this.atualizarExtrato();
    }

    atualizarExtrato = async () => {
        let filtros = [];
        let query = '';
        if (this.props.filtro.conta) filtros.push(`conta_id=${this.props.filtro.conta}`);
        if (this.props.filtro.status) filtros.push(`status=${this.props.filtro.status}`);
        if (this.props.filtro.tipo) filtros.push(`tipo=${this.props.filtro.tipo}`);
        if (this.props.filtro.orderBy) filtros.push(`orderBy=${this.props.filtro.orderBy}`);
        if (this.props.filtro.considerarPendentes) filtros.push(`considerarPendentes=${this.props.filtro.considerarPendentes}`);
        if (filtros.length > 0) query = `?${filtros.join('&')}`;
        try {
            const dataFormatada = this.props.filtro.data.format('YYYYMM');
            const res = await axios.get(`${ambiente.dev.server}/extratoCompleto/${dataFormatada}${query}`);
            this.setState({ extrato: res.data });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err.response.data}`);
        }
    }

    handleDeleteMovimentacao = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/transacoes/${id}`);
            this.props.exibirMensagem('yay', `Movimentação removida com sucesso!`);
            this.atualizarExtrato();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err.response.data}`);
        }
    }

    handleDeletePendings = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/transacoesPendentes/${id}`);
            this.props.exibirMensagem('yay', `Movimentações em aberto removidas com sucesso!`);
            this.atualizarExtrato();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err.response.data}`);
        }
    }

    handlePayMovimentacao = async (id) => {
        try {
            await axios.put(`${ambiente.dev.server}/transacoes/pagar/${id}`);
            this.props.exibirMensagem('yay', `Movimentação paga com sucesso!`);
            this.atualizarExtrato();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err.response.data}`);
        }
    }

    handleDeleteTransferencia = async (id) => {
        try {
            await axios.delete(`${ambiente.dev.server}/transferencias/${id}`);
            this.props.exibirMensagem('yay', `Transferência removida com sucesso!`);
            this.atualizarExtrato();
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err.response.data}`);
        }
    }

    render() {
        return (
            <div>
                <Filtro data conta tipo status pendentes ordem atualizar={this.atualizarExtrato} />
                <div className="list-group">
                    <li className="list-group-item list-group-item-action flex-column align-items-start">
                        <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1">Saldo Inicial</h5>
                            <small>{this.state.extrato.saldoInicial.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        </div>
                    </li>
                    {this.state.extrato.linhas.map(item => item.transferencia_id ?
                        (!this.props.filtro.conta && !this.props.filtro.tipo && item.valor < 0) ? null : <TransferenciaRow key={item.id} {...item} handleDelete={this.handleDeleteTransferencia} /> :
                        <MovimentacaoRow key={item.id} {...item} handleDelete={this.handleDeleteMovimentacao}
                            handlePay={this.handlePayMovimentacao} handleDeletePendings={this.handleDeletePendings} />
                    )}
                    <li className="list-group-item list-group-item-action flex-column align-items-start">
                        <div className="d-flex w-100 justify-content-between">
                            <h5 className="mb-1">Saldo Final</h5>
                            <small>{this.state.extrato.saldoFinal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        </div>
                    </li>
                </div>
            </div>
        );
    }
}

ExtratoMensal.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
    filtro: PropTypes.object.isRequired,
};

function mapStateToProps({ filtro }) {
    return {
        filtro: filtro
    };
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExtratoMensal);



// WEBPACK FOOTER //
// ./src/components/relatorios/ExtratoMensal.js